import _ from "lodash";

class ChannelTranslationService {
    getKey(channel) {
        return `utils.${this._normalizeChannel(channel)}`;
    }
    private _normalizeChannel(channel) {
        return _.camelCase(channel);
    }
}

export default ChannelTranslationService;
